import React, { ComponentProps } from "react";

import { Button, ImageView } from "@thenounproject/lingo-core";
import { Container, Inner } from "../Elements";
import { Title } from "./TitleSection";

type Props = {
  title: string;
  subtitle?: string;
  primaryButton?: Partial<ComponentProps<typeof Button>>;
  secondaryButton?: Partial<ComponentProps<typeof Button>>;
  image: { src: string; alt: string };
};

const ShowcaseSection: React.FC<Props> = ({
  title,
  subtitle,
  image,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <Container background="primary" my="none" py="xxl" px="none">
      <Inner
        mt="none"
        px="none"
        maxWidth="100%"
        alignItems="center"
        variations={{
          "mq.m": { flexDirection: "column" },
        }}>
        <Title
          title={title}
          subtitle={subtitle}
          style="dark"
          level="h2"
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        />
        <ImageView mt="xxl" width="100%" cover aspectRatio={(2 / 3) * 100} flex="1" {...image} />
      </Inner>
    </Container>
  );
};

export default ShowcaseSection;
